import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
import { convertModelToFormData } from '@application/helpers/form-data-helper';
const mapCreateToApi = (request) => {
    const mapped = {
        FullName: request.fullName,
        Description: request.description,
        Type: request.type,
        PartnershipStartDate: request.partnershipStartDate,
        PartnershipEndDate: request.partnershipEndDate,
        Logo: request.logo,
        CompanyIds: request.companyIds,
        PartnerInterestIds: request.partnerInterestIds ?? [],
        PartnerContactPersons: request.partnerContactPersons?.map((p) => ({
            FirstName: p.firstName,
            LastName: p.lastName,
            Name: p.name,
            PhoneNo: p.phoneNo,
            Email: p.email,
            IsPrimary: p.isPrimary,
            ProfilePicture: p.profilePicture
        })) ?? []
    };
    return mapped;
};
const mapUpdateToApi = (request) => {
    const mapped = {
        FullName: request.fullName,
        Description: request.description,
        Type: request.type,
        PartnershipStartDate: request.partnershipStartDate,
        PartnershipEndDate: request.partnershipEndDate,
        Logo: request.logo,
        CompanyIds: request.companyIds ?? [],
        PartnerInterestIds: request.partnerInterestIds ?? [],
        PartnerContactPersons: request.partnerContactPersons?.map((p) => ({
            Id: p.id,
            FirstName: p.firstName,
            LastName: p.lastName,
            Name: p.name,
            PhoneNo: p.phoneNo,
            Email: p.email,
            IsPrimary: p.isPrimary,
            ProfilePicture: p.profilePicture
        })) ?? []
    };
    return mapped;
};
const createPartner = (request) => {
    const formData = convertModelToFormData(mapCreateToApi(request));
    return vdkEmHappinessPortalApi.post('/partners/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const updatePartner = (request) => {
    const formData = convertModelToFormData(mapUpdateToApi(request));
    return vdkEmHappinessPortalApi.put(`/partners/${request.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const getAllPartners = (request) => {
    return vdkEmHappinessPortalApi.post('/partners/get-all', request);
};
const getPartnerById = (id) => {
    return vdkEmHappinessPortalApi.get(`/partners/${id}`);
};
const deletePartner = (id) => {
    return vdkEmHappinessPortalApi.delete(`/partners/${id}`);
};
const getAllPartnersByCompany = (companyIds) => {
    return vdkEmHappinessPortalApi.post('/partners/get-all-partners-by-company', {
        companyIds: companyIds
    });
};
const togglePartnerContract = (id) => {
    return vdkEmHappinessPortalApi.post(`/partners/${id}/toggle-contract`, {});
};
const getSuggestedPeopleForPartner = (request) => {
    return vdkEmHappinessPortalApi.post('/partners/suggested-people', request);
};
const partnerAPI = {
    createPartner,
    updatePartner,
    getAllPartners,
    getPartnerById,
    deletePartner,
    getAllPartnersByCompany,
    togglePartnerContract,
    getSuggestedPeopleForPartner
};
export default partnerAPI;
